module.exports = __webpack_public_path__ + "grapes.jpg?aa4efd87282f01e535896e3a8a9ac65f";